export const getStatusName = (language, data) => {
    switch (language) {
        case 'kz':
            return data?.kaz;
        case 'ru':
            return data?.rus;
        case 'ch':
            return data?.ch;
        case 'kg':
            return data?.kaz;
    }
};

export const getTurkeyStatus = (language) => {
    switch (language) {
        case 'kz':
            return 'Түркиядағы қоймада';
        case 'ru':
            return 'На складе в Турции';
        case 'ch':
            return '在土耳其的仓库里';
        case 'kg':
            return 'Түркия кампасында';
    }
};

export const getOnRoadTurkeyStatus = (language) => {
    switch (language) {
        case 'kz':
            return 'Түркия жолындағы тапсырыстар';
        case 'ru':
            return 'Заказы в пути из Турции';
        case 'ch':
            return '订单从土耳其发货途中';
        case 'kg':
            return 'Түркиядан жолдо келе жатат';
    }
};
